export default "__VITE_ASSET__922381dc__"